<page-header [title]="('admin.maintenance.migrations.onglets.maintenance.details.title' | translate) + ' ' + displayName"
             [listeItems]="listeTabItems"
             [selectedIndex]="selectedIndex"
             (onGoBack)="onGoBack()"
             [extraInfo]="applicationStatutAdmin | translate">
</page-header>

<list-view *ngIf="liste" [liste]="liste"></list-view>
